import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="w-9 h-5" />;
  }

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className={cn(
        "relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF3737] focus-visible:ring-offset-1 focus-visible:ring-offset-[#0d0d0f]",
        isDark ? "bg-white/20" : "bg-white/20"
      )}
    >
      <span
        className={cn(
          "pointer-events-none flex h-4 w-4 items-center justify-center rounded-full bg-white shadow-sm transition-transform duration-200",
          isDark ? "translate-x-[18px]" : "translate-x-0.5"
        )}
      >
        {isDark ? (
          <Moon className="h-2.5 w-2.5 text-slate-700" strokeWidth={2.5} />
        ) : (
          <Sun className="h-2.5 w-2.5 text-orange-500" strokeWidth={2.5} />
        )}
      </span>
    </button>
  );
}
